import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectTemplatesListItems } from "../../../../../redux/templates/selector";
import { templates } from "../../../../../redux/templates/action";
import { selectListItems } from "../../../../../redux/library/selector";

const ManagementTemplates = () => {
  const dispatch = useAppDispatch()

  const navigate = useNavigate()
  const libraryData = useSelector(selectListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const TemplatesItems = useSelector(selectTemplatesListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Template Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'TemplateTypeId', headerName: 'Template Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.TemplateType } },
      { field: 'WebTemplateTypeId', headerName: 'Web Template Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.WebTemplateType } },
      { field: 'IsApproved', headerName: 'Approved', cellRenderer: 'yesNoRenderer' }

    ]);
  }

  const fetchTemplates = () => {
    dispatch(templates.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/templates/fetch`, entity: 'templates', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }


  const handleAdd = () => {
    navigate(`${0}`)
  }

  useEffect(() => {
    createColumnDefs()
    fetchTemplates()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(templates.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/delete`,
      entity: 'templates',
      jsonData: {
        Records: [
          {

            Id: data?.MarketingTemplateId
          }

        ]
      }
    })).then(() => {
      fetchTemplates()
    });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.MarketingTemplateId}`)
  }
  const handleReloadData = () => {
    fetchTemplates()
  }

 const handlePublishscheduledTasks = async () => {
    await dispatch(templates.resetAction({ actionType: 'create' }))
    await dispatch(templates.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/templates/publish`,
      entity: 'templates',
      jsonData:
      {
        "Context": {},
        "Records": [
          {}
        ]
      }
    })).then(() => {
      fetchTemplates();
    });
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Templates</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 98.432 98.432" width="24" height="24">
          <title>Publish Templates </title>
          <path d="M49.246,37.366v-2.035c0-0.818-0.463-1.563-1.194-1.927c-0.732-0.367-1.604-0.282-2.257,0.208l-9.804,7.403 c-0.542,0.406-0.858,1.044-0.858,1.72c0,0.674,0.316,1.311,0.858,1.717l9.804,7.399c0.653,0.489,1.525,0.571,2.257,0.207 c0.73-0.366,1.194-1.112,1.194-1.929v-1.9c8.287,0.811,15.023,6.995,16.441,15.083c0.32,1.729,1.811,2.976,3.561,2.976h3.602 c1.049,0,2.055-0.447,2.734-1.246c0.689-0.791,0.993-1.848,0.833-2.893C74.385,48.664,63.104,38.207,49.246,37.366z"></path>
          <path d="M62.447,79.344l-9.807-7.396c-0.65-0.492-1.524-0.574-2.256-0.211c-0.731,0.368-1.194,1.112-1.194,1.93v1.898 c-8.289-0.811-15.024-6.993-16.441-15.083c-0.321-1.728-1.809-2.974-3.56-2.974h-3.603c-1.052,0-2.054,0.447-2.735,1.246 c-0.689,0.791-0.995,1.848-0.834,2.893C24.051,75.129,35.331,85.59,49.189,86.43v2.035c0,0.816,0.463,1.564,1.194,1.928 c0.732,0.365,1.606,0.283,2.257-0.209l9.806-7.404c0.538-0.406,0.856-1.043,0.856-1.717C63.303,80.387,62.984,79.75,62.447,79.344 z"></path>
          <path d="M78.73,22.878c-0.699-0.058-1.342-0.416-1.76-0.98c-4.012-5.43-10.453-8.78-17.307-8.78c-0.436,0-0.872,0.014-1.309,0.04 c-0.58,0.035-1.152-0.138-1.617-0.488c-4.17-3.151-9.225-4.858-14.52-4.858c-9.481,0-17.896,5.498-21.82,13.822 c-0.352,0.746-1.056,1.263-1.873,1.377C8.074,24.463,0,33.46,0,44.308C0,55.233,8.205,64.238,18.77,65.59 c-0.285-1.098-0.536-2.209-0.708-3.348c-0.29-1.886,0.147-3.791,1.199-5.357l-1.123-0.004c-5.556-1.487-9.667-6.553-9.667-12.573 c0-7.186,5.846-13.03,13.032-13.03c0.363,0,0.72,0.029,1.074,0.058c2.07,0.159,3.946-1.184,4.45-3.191 c1.752-6.982,8-11.86,15.19-11.86c4.108,0,7.997,1.587,10.95,4.468c1.009,0.985,2.442,1.402,3.822,1.115 c0.879-0.183,1.778-0.274,2.673-0.274c5.029,0,9.521,2.826,11.725,7.379c0.773,1.601,2.465,2.555,4.235,2.373 c0.44-0.045,0.88-0.066,1.308-0.066c7.186,0,13.03,5.845,13.03,13.03c0,6.356-4.578,11.649-10.606,12.793 c0.432,1.446,0.787,2.929,1.017,4.452c0.212,1.378,0.039,2.768-0.479,4.025c10.457-1.451,18.541-10.422,18.541-21.271 C98.434,33.058,89.748,23.795,78.73,22.878z">
          </path>
        </svg>,
      callback: () => handlePublishscheduledTasks(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(templates.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/templates/fetch`,
      entity: 'templates',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }
  return (
    <>
      {TemplatesItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={TemplatesItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          enableFilter={true} onSearch={handleSearch} paginationData={TemplatesItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Templates" />

      }
    </>
  );
};

export default ManagementTemplates;


